export default __webpack_public_path__ + "static/media/wellcome-img.fe95f307.png";